import { prepareComponentToken, prepareToken } from '.';
import capitalize from '../../_util/capitalize';
import { genSubStyleComponent } from '../../theme/internal';
const genTagStatusStyle = (token, status, cssVariableType) => {
  const capitalizedCssVariableType = capitalize(cssVariableType);
  return {
    ["".concat(token.componentCls).concat(token.componentCls, "-").concat(status)]: {
      color: token["color".concat(cssVariableType)],
      background: token["color".concat(capitalizedCssVariableType, "Bg")],
      borderColor: token["color".concat(capitalizedCssVariableType, "Border")],
      ["&".concat(token.componentCls, "-borderless")]: {
        borderColor: 'transparent'
      }
    }
  };
};
// ============================== Export ==============================
export default genSubStyleComponent(['Tag', 'status'], token => {
  const tagToken = prepareToken(token);
  return [genTagStatusStyle(tagToken, 'success', 'Success'), genTagStatusStyle(tagToken, 'processing', 'Info'), genTagStatusStyle(tagToken, 'error', 'Error'), genTagStatusStyle(tagToken, 'warning', 'Warning')];
}, prepareComponentToken);